export type SupportedLocale =
  | 'en-GB'
  | 'en-US'
  | 'pt-br'
  | 'zh-TW'
  | 'bg'
  | 'cs'
  | 'da'
  | 'de'
  | 'en'
  | 'es'
  | 'fi'
  | 'fr'
  | 'hr'
  | 'hu'
  | 'it'
  | 'ja'
  | 'ko'
  | 'nb'
  | 'nl'
  | 'pl'
  | 'pt'
  | 'ru'
  | 'sv'
  | 'tr'
  | 'uk'
  | 'zh';

export const SUPPORTED_LOCALES = new Set<SupportedLocale>([
  'en-GB',
  'en-US',
  'pt-br',
  'zh-TW',
  'bg',
  'cs',
  'da',
  'de',
  'en',
  'es',
  'fi',
  'fr',
  'hr',
  'hu',
  'it',
  'ja',
  'ko',
  'nb',
  'nl',
  'pl',
  'pt',
  'ru',
  'sv',
  'tr',
  'uk',
  'zh',
]);

export const DEFAULT_LOCALE: SupportedLocale = 'en';

const patterns: [RegExp, SupportedLocale][] = [
  [/^en-GB/i, 'en-GB'],
  [/^en-US/i, 'en-US'],
  [/^pt-br/i, 'pt-br'],
  [/^zh-TW/i, 'zh-TW'],
  [/^bg/i, 'bg'],
  [/^cs/i, 'cs'],
  [/^da/i, 'da'],
  [/^de/i, 'de'],
  [/^en/i, 'en'],
  [/^es/i, 'es'],
  [/^fi/i, 'fi'],
  [/^fr/i, 'fr'],
  [/^hr/i, 'hr'],
  [/^hu/i, 'hu'],
  [/^it/i, 'it'],
  [/^ja/i, 'ja'],
  [/^ko/i, 'ko'],
  [/^nb/i, 'nb'],
  [/^nl/i, 'nl'],
  [/^pl/i, 'pl'],
  [/^pt/i, 'pt'],
  [/^ru/i, 'ru'],
  [/^sv/i, 'sv'],
  [/^tr/i, 'tr'],
  [/^uk/i, 'uk'],
  [/^zh/i, 'zh'],
];

export const supportsLocale = (locale: string): boolean => {
  try {
    return Boolean(
      (patterns.find(([pattern]) => pattern.test(locale)) ||
        patterns.find(([pattern]) => pattern.test(locale.split('-')[0])) || [, false])[1],
    );
  } catch {
    return false;
  }
};

export const matchLocale = (locale: string): SupportedLocale => {
  try {
    return (patterns.find(([pattern]) => pattern.test(locale)) ||
      patterns.find(([pattern]) => pattern.test(locale.split('-')[0])) || [, DEFAULT_LOCALE])[1];
  } catch {
    return DEFAULT_LOCALE;
  }
};

export const getLanguage = (locale: string): string =>
  matchLocale(locale).split('-')[0].toLowerCase();
